module.exports = __webpack_public_path__ + "static/media/microphone-solid.2bb2da82.svg";